<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About The Author</h1>
<p style="text-indent:00em;">By the same author:</p><br/>
<p style="text-indent:00em;"><em>The Liberals in Hampshire - a part(l)y history.</em></p>
<p style="text-indent:00em;"><em>Part 1: Southampton 1958-65: object lessons</em></p>
<p style="text-indent:00em;"><em>Part 2: Eastleigh 1965-72: out in the suburbs, something stirred!</em></p>
<p style="text-indent:00em;"><em>Part 3: Eastleigh 1972-81: the thorn in the flesh bursts into flower</em></p>
<p style="text-indent:00em;"><em>Part 4: Eastleigh 1978-85: a campaign in pictures - politics can be fun!</em></p>
<p style="text-indent:00em;"><em>Part 5: Eastleigh 1981-90: control!</em></p>
<p style="text-indent:00em;">Martin Kyrle’s <em>Little Green Nightbook</em></p>
<p style="text-indent:00em;">Martin Kyrle’s <em>Little Blue Nightbook</em></p>
<p style="text-indent:00em;"><em>Jottings from the Trans-Siberian Railway</em></p>
<p style="text-indent:00em;"><em>Jottings from Russia and the Baltic States. Part 1: Russia and Estonia</em></p>
<p style="text-indent:00em;"><em>A 20-20 Vision. Turning Britain into a liberal democracy</em></p><br/>
<p style="text-indent:00em;">In preparation:</p><br/>
<p style="text-indent:00em;"><em>Jottings from Russia and the Baltic States. Part 2: Latvia, Lithuania and Finland</em></p>
<p style="text-indent:00em;"><em>A Victorian Childhood</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?9db671be